const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the group list search directive
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('groupListSearch', ['Application', 'Groups', '$q', function (Application, Groups, $q) {
  return {
    restrict: 'E',
    scope: {
      selections: '=?',
      onChange: '&?',
      hideSelections: '@',
      managerSubset: '=?',
      viewRestricted: '=?'
    },
    template: require('../../../templates/directives/groups/group-list-search.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.creator = Application.access.user;
      self.searchText = '';
      self.queries = [];
      self.options = [];
      self.managerOptions = [];
      self.managerSelections = [];
      self.restrictedManagerSelections = [];

      self.fullGroups = {};

      // Get category options based on input
      self.getOptions = function(input) {
        var deferred = $q.defer();

        input = input ? input.toLowerCase() : '';

        if (!input) {
          return deferred.resolve([]);
        }

        var query = {
          name: '$regex,2,' + input + ',i',
          page: 1,
          per_page: 40
        };

        if ($scope.selections && $scope.selections.length) {
          query['_id'] = '$nin,' + $scope.selections.length + ',' + $scope.selections.join(',');
        }

        self.options.splice(0);

        Groups.find(query).$promise
        .then(function(data) {

          data.forEach(function(item) {
            item.text = item.name;
          });

          deferred.resolve(data || []);

        }).catch(function(error) {
          console.log('error in categories search: ', error);
        });

        return deferred.promise;

      };

      // Add selection to selections
      self.itemAdding = function(item) {
        if (!item) {
          return false;
        }

        self.searchText = '';
        self.fullGroups[item._id] = item;

        for (var i = 0; i < $scope.selections.length; i++) {
          if ($scope.selections[i] === item._id) {
            return false;
          }
        }

        $scope.selections.push(item._id);

        if ($scope.onChange) {
          $scope.onChange({item: item});
        }

        self.options.splice(0);

        return false;
      };

      // Add selection to selections
      self.removeSelection = function(item) {
        if (!item) {
          return false;
        }


        for (var i = 0; i < $scope.selections.length; i++) {
          if ($scope.selections[i] === item) {
            $scope.selections.splice(i, 1);
            break;
          }
        }

        if ($scope.onChange) {
          $scope.onChange({item: item});
        }

        self.options.splice(0);

        return false;
      };

      self.setManagerValue = function() {
        $scope.selections = self.managerSelections;
      };

      self.addToManagerValue = function() {
        $scope.selections = self.restrictedManagerSelections.concat(self.managerSelections);
      }

      self.init = function() {
        var selections = $scope.selections || [];

        if ($scope.managerSubset) {
          selections = self.creator && self.creator.managing_groups || [];
        }

        if (!selections || !selections.length) {
          return;
        }

        self.loading = true;
        Groups.find({_id: '$in,' + selections.length + ',' + selections.join(','), fields: '_id,name'}).$promise
        .then(function(results) {
          results.forEach(function(item) {
            self.fullGroups[item._id] = item;
            item.text = item.name;
            item.value = item._id;
          });

          if ($scope.managerSubset) {
            self.managerOptions = results;
            if ($scope.selections && $scope.selections.length) {
              self.managerOptions.forEach(function(item) {
                if ($scope.selections.indexOf(item._id) !== -1) {
                  self.managerSelections.push(item._id);
                } 
              }); 
            }


            $scope.$watch('groupSearch.managerSelections', function(newVal, oldVal) {
              if (!oldVal || newVal === oldVal) {
                return;
              }
              if ($scope.viewRestricted) {
                self.addToManagerValue();
                return;
              }
              self.setManagerValue();
            });
          }

          if ($scope.managerSubset && $scope.viewRestricted) {
            var restricted = $scope.selections.filter(selection => {
              return !self.managerSelections.includes(selection);
            })
            Groups.find({_id: '$in,' + restricted.length + ',' + restricted.join(','), fields: '_id,name'}).$promise
            .then(function(restrictedResults) {
              restrictedResults.forEach(function(result) {
                result.text = result.name;
                result.value = result._id;
              });
              self.restrictedManagerSelections = restrictedResults;
              self.loading = false;
            }).catch(function(error) {
              self.loading = false;
              console.log('error: ', error);
            });
          } else {
            self.loading = false;
          }
        }).catch(function(error) {
          self.loading = false;
          console.log('error: ', error);
        });
      };

      self.init();

    }],
    controllerAs: 'groupSearch'
  };
}]);